<div class="loginContainer">
  <form nz-form class="login" [formGroup]="loginForm">
    <div class="logo">
      <img src="./assets/Diazar.svg" alt="Diazar Logo" />
      <span>Diazar</span>
    </div>
    <p class="title">Bienvenido</p>
    <p class="description">Es necesario que inicies sesión para ingresar a Diazar Control</p>
    <p class="description"><span class="required">*</span> Ingresa tu empresa</p>
    <nz-form-control>
      <input nz-input type="text" class="input" placeholder="Nombre de la empresa"
      formControlName="companyName"/>
    </nz-form-control>
    <button nz-button nzType="primary" type="submit" (click)="onLogin()"
      [disabled]="!loginForm.valid">Ir a Iniciar Sesión</button>
  </form>
</div>
